module.exports = __webpack_public_path__ + "img/21.3b1a36fc.svg";